<template>
  <div class="py-4 container-fluid">
    <div class="d-flex justify-content-end mb-4 me-4">
      <select id="monthDay" v-model="state.selectedType" class="px-3 py-2">
        <option value="DIARIO">Diário</option>
        <option value="MENSAL">Mensal</option>
      </select>
    </div>
    
    <div class="row">
      <!-- Cards para visualização MENSAL -->
      <div v-if="state.selectedType === 'MENSAL'" class="row">
        <div  class="col-4" v-for="mes in getMeses()" :key="mes">
          <div class="card mb-3">
            <div class="card-header">
              <div class="row">
                <div class="col-md d-flex gap-4">
                  <div>
                    <h3 style="white-space: nowrap">Pontuação</h3>
                    <h5>{{ mes }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr style="background-color: #56008f">
                      <th scope="col">Colaborador</th>
                      <th scope="col">Pontos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="colaborador in state.colaboradores"
                      :key="colaborador.id"
                    >
                      <td>{{ colaborador.nome }}</td>
                      <td>{{ getPontosPorMes(colaborador.id, mes) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Cards para visualização DIÁRIA -->
      <div v-if="state.selectedType === 'DIARIO'" class="row">
        <div class="col-4" v-for="dia in getDias()" :key="dia.key">
          <div class="card mb-3">
            <div class="card-header">
              <div class="row">
                <div class="col-md d-flex gap-4">
                  <div>
                    <h3 style="white-space: nowrap">Pontuação</h3>
                    <h5>{{ dia.display }}</h5>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-hover">
                  <thead>
                    <tr style="background-color: #56008f">
                      <th scope="col">Colaborador</th>
                      <th scope="col">Pontos</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="colaborador in state.colaboradores"
                      :key="colaborador.id"
                    >
                      <td>{{ colaborador.nome }}</td>
                      <td>{{ getPontosPorDia(colaborador.id, dia.mes, dia.dia) }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import services from "../../services";
import { useStorage } from "vue3-storage";

export default {
  setup() {
    const storage = useStorage();
    const token = storage.getStorageSync("token");
    const state = reactive({
      colaboradores: [],
      pontuacoesDia: [],
      pontuacoesMensal: [],
      pontuacoesRaw: {}, // Para armazenar os dados brutos da API
      selectedType: "DIARIO",
    });

    onMounted(() => {
      fetchColaborador();
      fetchPontuacoesDia();
      fetchPontuacoesMensal();
    });

    async function fetchColaborador() {
      try {
        const { data } = await services.colaboradores.getAll({ token });
        state.colaboradores = data;
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchPontuacoesDia() {
      try {
        const { data } = await services.pontuacoes.getAllDia({ token });
        state.pontuacoesRaw = data; // Armazena dados brutos

        const acumulado = {};
        Object.values(data).forEach((dias) => {
          Object.values(dias).forEach((lista) => {
            lista.forEach((item) => {
              const id = item.colaborador.id;
              const pontos = Number(item.pontos) || 0;

              if (!acumulado[id]) {
                acumulado[id] = { colaborador_id: id, pontos: 0 };
              }
              acumulado[id].pontos += pontos;
            });
          });
        });

        state.pontuacoesDia = Object.values(acumulado);
      } catch (error) {
        console.log(error);
      }
    }

    async function fetchPontuacoesMensal() {
      try {
        const { data } = await services.pontuacoes.getAllMensal({ token });
        state.pontuacoesRaw = data; // Armazena dados brutos

        const acumulado = {};
        Object.values(data).forEach((dias) => {
          Object.values(dias).forEach((lista) => {
            lista.forEach((item) => {
              const id = item.colaborador.id;
              const pontos = Number(item.pontos) || 0;

              if (!acumulado[id]) {
                acumulado[id] = { colaborador_id: id, pontos: 0 };
              }
              acumulado[id].pontos += pontos;
            });
          });
        });

        state.pontuacoesMensal = Object.values(acumulado);
      } catch (error) {
        console.log(error);
      }
    }

    // Função para obter lista de meses
    function getMeses() {
      return Object.keys(state.pontuacoesRaw);
    }

    // Função para obter lista de dias
    function getDias() {
      const dias = [];
      Object.keys(state.pontuacoesRaw).forEach(mes => {
        Object.keys(state.pontuacoesRaw[mes]).forEach(dia => {
          dias.push({
            key: `${mes}-${dia}`,
            display: `${dia} - ${mes}`,
            mes: mes,
            dia: dia
          });
        });
      });
      return dias;
    }

    // Função para obter pontos por mês
    function getPontosPorMes(colaboradorId, mes) {
      let totalPontos = 0;
      const mesData = state.pontuacoesRaw[mes];
      
      if (mesData) {
        Object.values(mesData).forEach(diaData => {
          diaData.forEach(item => {
            if (item.colaborador.id === colaboradorId) {
              totalPontos += Number(item.pontos) || 0;
            }
          });
        });
      }
      
      return totalPontos;
    }

    // Função para obter pontos por dia específico
    function getPontosPorDia(colaboradorId, mes, dia) {
      const diaData = state.pontuacoesRaw[mes]?.[dia];
      
      if (diaData) {
        const colaboradorData = diaData.find(item => item.colaborador.id === colaboradorId);
        return colaboradorData ? Number(colaboradorData.pontos) || 0 : 0;
      }
      
      return 0;
    }

    function getPontos(colaboradorId) {
      const list = state.selectedType === "DIARIO" 
        ? state.pontuacoesDia 
        : state.pontuacoesMensal;
      const pontuacao = list.find((p) => p.colaborador_id === colaboradorId);
      return pontuacao ? pontuacao.pontos : 0;
    }

    async function deletar(id) {
      if (confirm("Deseja deletar está cliente?")) {
        try {
          state.isLoading = true;
          const { data } = await services.colaboradores.delete({
            id: id,
            token,
          });
          if (data.status != 200) {
            alert("Erro ao deletar!.");
          } else {
            fetchColaborador();
          }
        } catch (error) {
          console.log(error);
        }
      }
    }

    return {
      state,
      deletar,
      getPontos,
      getMeses,
      getDias,
      getPontosPorMes,
      getPontosPorDia,
    };
  },
};
</script>

<style scoped>
h5 {
  color: #000;
}

tr {
  text-align: center;
}

th,
td {
  padding: 4px !important;
}

th {
  color: #fff;
}

td {
  border-bottom: solid 1px #000 !important;
  color: #000;
}

.card {
  border: solid 2px #000;
  border-radius: 10px;
  background-color: #fff;
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

#btn_new_user {
  color: #000;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #000;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}

#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}

.table-hover > tbody > tr:hover > * {
  color: rgb(0, 0, 0);
  background-color: rgb(225, 225, 225);
}

select {
  border: 2px solid #56008f;
  border-radius: 5px;
  background-color: white;
  color: #56008f;
  font-weight: bold;
}

select:focus {
  outline: none;
  border-color: #56008f;
  box-shadow: 0 0 5px rgba(86, 0, 143, 0.3);
}
</style>